<template>
  <table class="sellersResults">
    <thead>
      <th width="20%" v-if="LMSGsupplierconfig">{{ $t('common.idtfr') }}</th>
      <th width="20%">{{ $t('common.srn') }}</th>
      <th width="20%" class="showLargeScreenOnly">{{ $t('common.social_reason') }}</th>
      <th width="40%">{{ $t('common.kyc_status') }}</th>
      <th v-if="LMSGsupplierconfig">{{ $t('common.payment_status') }}</th>
      <th v-if="LMSGsupplierconfig" class="showLargeScreenOnly">{{ $t('common.balance') }}</th>
      <!-- <th width="5%">{{ $t('common.actions') }}</th> -->
    </thead>
    <tbody>

      <template v-if="sellers.length > 0">
        <tr v-for="seller in sellers" :key="seller.IdSeller"
          @click="seeSupplierDetails(seller)"
          class="boxRequest"
          :style="{background: getSeenStatusBackground(seller.TotalToValidateDocuments), fontWeight: getSeenStatusFontWeight(seller.TotalToValidateDocuments)}">
          <td v-if="LMSGsupplierconfig">{{ seller.SellerIdentifier }}</td>
          <td>{{ seller.Siren }}</td>
          <td class="showLargeScreenOnly">{{ seller.SocialReason }}</td>
          <td>
            <i class="icon list-icon" :class="getKYCIcon(seller)"></i>
            {{ getKYCStatus(seller) }}
          </td>
          <td v-if="LMSGsupplierconfig">
            <i class="icon list-icon" :class="getPaymentIcon(seller)"></i>
            {{ getPaymentStatus(seller) }}
          </td>

          <td v-if="LMSGsupplierconfig" class="showLargeScreenOnly">1500 €</td>
          <!-- Edit & Delete button to do asap -->
          <!-- <td>
            <button class="button-swipe-out" @click="editSupplier(seller.IdSeller, $event)">
              <f7-icon f7="" class="fa fa-pencil button-edit close_margin"></f7-icon>
            </button>
            <button class="button-swipe-out" @click="deleteSupplier(seller.IdSeller, $event)">
              <f7-icon f7="close" class="button-delete close_margin"></f7-icon>
            </button>
          </td> -->
        </tr>
      </template>

      <tr v-else>
        <td colspan="6" class="noResult">
          {{ $t('common.no_result') }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import BusinessDocumentReturnForm from '@/pages/requests/detailPages/businessDocumentDetailPages/BusinessDocumentReturnForm.vue'
import BusinessDocumentList from '@/pages/requests/detailPages/businessDocumentDetailPages/BusinessDocumentList.vue'
import { errorMessageAlert } from '@/helpers/alert'
import { getSeenStatusBackground, getSeenStatusFontWeight, statusIcon, statusLabel } from '@/helpers/labels'
import { loadPage } from '@/helpers/routing'
/** @author TLV 15/02/2021
* @brief Refonte de la liste des comptes vendeurs, qui devient un component indépendant
*       de TransactionsList pour s'adapter correctement aux dernières maquettes, qui
*       demandent beaucoup de changements par rapport aux listes des RTP/DP/etc.
*/
export default {
  name: 'SuppliersList',
  props: ['sellers', 'documents'],
  components: {
    'business-document-return-form': BusinessDocumentReturnForm,
    'documents-list': BusinessDocumentList
  },
  data () {
    return {
      detailsDone: false,
      LMSGsupplierconfig: this.$engine.services.suppliers.LMSGsupplierconfig
    }
  },
  // created () {
  //   let selectedSupplier = this.$engine.services.suppliers.selectedSupplier
  //   if (selectedSupplier) {
  //     this.$engine.services.suppliers.selectedSupplier = null
  //     this.seeSupplierDetails(selectedSupplier)
  //   }
  // },
  methods: {
    deleteSupplier (idSeller, sellerIdentifier) {
      // to do asap
    },
    editSupplier (idSeller) {
      loadPage(this, {
        url: '/suppliers/edit/' + '?IdAccount=' + this.$engine.user.get().id + '&IdSeller=' + idSeller
      })
    },
    getDocumentDetails (documentId) {
      let that = this
      this.$engine.services.businessDocuments.getDocumentDetails(documentId)
      .then(resp => {
        that.documents[that.documents.map(function (e) { return e.IdDocument }).indexOf(resp.data.Documents[0].IdDocument)] = resp.data.Documents[0]
        that.$forceUpdate()
        // that.activateSpinner = false
        // that.detailsDone = true
      })
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getFolderInfo () {
      let that = this
      this.$engine.services['businessDocuments'].update(
        '',
        1000,
        1,
        this.$engine.services['businessDocuments'].filter.getConditionObject()
      ).then(resp => {
        let groups = resp.data.groups
        for (var i = 0; i < groups.length; i++) {
          if (groups[i].idgroup === that.$engine.services.businessDocuments.currentSendbox.idgroup) {
            that.$engine.services.businessDocuments.currentSendbox = groups[i]
            that.currentFolder = []
            that.currentFolder.push(that.$engine.services.businessDocuments.currentSendbox)
            break
          }
        }
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    getKYCIcon (seller) {
      return statusIcon(seller.Status)
    },
    getKYCStatus (seller) {
      return statusLabel(this.$i18n, 'Provider_' + seller.Status)
    },
    getPaymentIcon (seller) {
      return statusIcon(seller.Status)
    },
    getPaymentStatus (seller) {
      return statusLabel(this.$i18n, 'Seller_' + seller.Status)
    },
    getSeenStatusBackground (totalToValidateDocuments) {
      if (totalToValidateDocuments > 0) {
        return getSeenStatusBackground('0')
      } else {
        return getSeenStatusBackground('1')
      }
    },
    getSeenStatusFontWeight (totalToValidateDocuments) {
      if (totalToValidateDocuments > 0) {
        return getSeenStatusFontWeight('0')
      } else {
        return getSeenStatusFontWeight('1')
      }
    },
    showReturningDocButtons (documentStatus, role) {
      return this.documentReturnDocStatusList.includes('Doc_' + documentStatus) && role.toString() === '1'
    },
    seeSupplierDetails (seller) {
      this.$engine.services.suppliers.selectedSupplier = seller
      loadPage(this, { url: '/suppliers/details/' })
    }
  }
}
</script>
<style scoped>
.sellersResults {
  width: 100%;
}

.sellersResults th {
  border: 1px solid silver;
  height: 40px;
  background-color: black;
  color: white;
  font-weight: normal;
}

.sellersResults tbody tr td {
  border-top: 1px solid silver;
  padding-top: 5px;
  padding-bottom: 5px;
}

.sellersResults tbody tr td,.sellersResults thead th {
  text-align: center;
}
/* Tests pour l'alignement de padding-left, à revoir quand on aura plusieurs statuts et labels alignés */
/* padding-left commun à toutes les colonnes sauf à celles des status */
/* .sellersResults tbody tr td:first-child, .sellersResults th:first-child,
.sellersResults tbody tr td:nth-child(2), .sellersResults th:nth-child(2),
.sellersResults tbody tr td:nth-child(5), .sellersResults th:nth-child(5) {
  padding-left: 5%;
}

.sellersResults tbody tr td:last-child {
  padding-left: 5
} */

/* Alignement des icônes et labels sur grand écran */
/* @media (min-width: 993px) {
  .sellersResults th:nth-child(3), .sellersResults th:nth-child(4) {
    padding-left: 80px;
  }
  .sellersResults tbody tr td:nth-child(3), .sellersResults tbody tr td:nth-child(4)  {
    padding-left: 55px;
  }
}
@media (max-width: 992px) {
  .sellersResults th:nth-child(3), .sellersResults th:nth-child(4),
  .sellersResults tbody tr td:nth-child(3), .sellersResults tbody tr td:nth-child(4)  {
    text-align: center;
  }
} */

.sellersResults {
  border: 1px solid silver;
  overflow: hidden;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 0 0 15px 15px;
  border: 1px solid silver;
}

tr:hover {
  background-color: #DCEEE8;
}

</style>



// WEBPACK FOOTER //
// SuppliersList.vue?47f65990